export const ALBUM_MANUAL_MATCHING_FILTERS = {
  ALL: 'All photos',
  UNMATCHED: 'Photos without face tags',
};

export const ALBUM_MANUAL_MATCHING_IDENTITY_FILTERS = {
  ALL: 'All',
  WITHOUT_MATCHES: 'Members without matches',
};
